import { Controller } from "@api/config";
import type { IRequestConfig } from "@api/config";

import { IGetTokensInFileRequest, IGetTokensInfoHistoryRequest } from "./request.types";
import type { TGetTokensInfoHistoryResponse, TGetTokensPast12hResponse } from "./response.types";

class TokensInformationController extends Controller {
	public constructor() {
		super({ requestUrl: "models/statistic/tokens" });
	}

	/**@GET TOKENS PAST 12H */
	public async getTokensPast12hAsync({ token }: IRequestConfig) {
		return this.get<TGetTokensPast12hResponse>("base", "", { token });
	}

	/**@GET TOKENS INFO HISTORY */
	public async getTokensInfoHistoryAsync({ token, limit, offset, dateFrom, dateTo }: IGetTokensInfoHistoryRequest) {
		return this.get<TGetTokensInfoHistoryResponse>(
			"base",
			`/history?limit=${limit}&dateFrom=${dateFrom}&dateTo=${dateTo}&offset=${offset}`,
			{ token },
		);
	}

	public async getTokensInFileAsync({ token, filetype, dateFrom, dateTo }: IGetTokensInFileRequest) {
		return this.get<File>("base", `/history/${filetype}?dateFrom=${dateFrom}&dateTo=${dateTo}`, {
			token,
			responseType: "blob",
		});
	}
}

export const tokensInformationAPI = new TokensInformationController();
